import React, { useContext } from 'react';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLayerGroup,
  faClock,
  faCheckCircle,
  faExclamationCircle,
  faCodeBranch
} from '@fortawesome/free-solid-svg-icons';

const ReportKpiCards = ({ counts = {}, activeStatus = 'todos', onSelectStatus }) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  const cardMap = {
    todos: {
      id: 'todos',
      label: 'TODOS',
      mobileLabel: 'TODOS',
      count: counts.todos ?? 0,
      icon: faLayerGroup,
      color: isDark ? '#38bdf8' : '#0284c7',
      bgLight: '#e0f2fe',
      bgDark: 'rgba(56, 189, 248, 0.15)',
      activeBorder: isDark ? '#38bdf8' : '#0284c7'
    },
    resueltos: {
      id: '2',
      label: 'RESUELTOS',
      mobileLabel: 'RESUELTOS',
      count: counts.cerrados ?? 0,
      icon: faCheckCircle,
      color: '#059669',
      bgLight: '#d1fae5',
      bgDark: 'rgba(16, 185, 129, 0.15)',
      activeBorder: '#10b981'
    },
    pendientes: {
      id: '1',
      label: 'PENDIENTES',
      mobileLabel: 'PEND.',
      count: counts.pendientes ?? 0,
      icon: faClock,
      color: '#d97706',
      bgLight: '#fef3c7',
      bgDark: 'rgba(245, 158, 11, 0.15)',
      activeBorder: '#f59e0b'
    },
    enProgreso: {
      id: '3',
      label: 'EN PROGRESO',
      mobileLabel: 'PROGRESO',
      count: counts.enProgreso ?? 0,
      icon: faExclamationCircle,
      color: '#2563eb',
      bgLight: '#dbeafe',
      bgDark: 'rgba(59, 130, 246, 0.15)',
      activeBorder: '#3b82f6'
    },
    combinados: {
      id: 'combinados',
      label: 'COMBINADOS',
      mobileLabel: 'COMB.',
      count: counts.combinados ?? 0,
      icon: faCodeBranch,
      color: isDark ? '#c084fc' : '#7c3aed',
      bgLight: '#f3e8ff',
      bgDark: 'rgba(168, 85, 247, 0.15)',
      activeBorder: '#8b5cf6'
    }
  };

  const desktopCards = [
    cardMap.todos,
    cardMap.pendientes,
    cardMap.enProgreso,
    cardMap.resueltos,
    cardMap.combinados
  ];

  const renderCard = (card, isMobile = false) => {
    const isActive = activeStatus === card.id;
    const label = isMobile ? card.mobileLabel : card.label;

    return (
      <div
        className={`p-2 ${isMobile ? '' : 'p-sm-3'} rounded-3 border d-flex align-items-center justify-content-between h-100 transition-base`}
        style={{
          backgroundColor: isDark ? '#121e2d' : '#ffffff',
          borderColor: isActive ? card.activeBorder : (isDark ? '#233142' : '#e2e8f0'),
          boxShadow: isActive ? `0 0 0 1px ${card.activeBorder}` : 'none',
          cursor: 'pointer'
        }}
        onClick={() => onSelectStatus(card.id)}
        title={`Filtrar por ${card.label.toLowerCase()}`}
      >
        <div className="me-1 overflow-hidden min-w-0">
          <span
            className="text-muted d-block text-truncate mb-1"
            style={{
              fontSize: isMobile ? '0.62rem' : '0.68rem',
              fontWeight: 600,
              letterSpacing: '0.02em'
            }}
          >
            {label}
          </span>
          <h3
            className="fw-bold mb-0"
            style={{
              color: card.color,
              lineHeight: 1.1,
              fontSize: isMobile ? '1.15rem' : '1.35rem'
            }}
          >
            {card.count}
          </h3>
        </div>
        <div
          className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            width: isMobile ? '28px' : '36px',
            height: isMobile ? '28px' : '36px',
            backgroundColor: isDark ? card.bgDark : card.bgLight,
            color: card.color,
            fontSize: isMobile ? '0.74rem' : '0.9rem'
          }}
        >
          <FontAwesomeIcon icon={card.icon} />
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Vista Móvil: 2 filas */}
      <div className="d-md-none mb-3">
        {/* Fila 1: 2 cards (TODOS y RESUELTOS) */}
        <div className="row g-2 mb-2">
          <div className="col-6">
            {renderCard(cardMap.todos, true)}
          </div>
          <div className="col-6">
            {renderCard(cardMap.resueltos, true)}
          </div>
        </div>

        {/* Fila 2: 3 cards (PEND., PROGRESO, COMB.) */}
        <div className="row g-2">
          <div className="col-4">
            {renderCard(cardMap.pendientes, true)}
          </div>
          <div className="col-4">
            {renderCard(cardMap.enProgreso, true)}
          </div>
          <div className="col-4">
            {renderCard(cardMap.combinados, true)}
          </div>
        </div>
      </div>

      {/* Vista Escritorio: Fila original */}
      <div className="d-none d-md-block mb-3 mb-sm-4">
        <div className="row g-2 g-sm-3">
          {desktopCards.map(card => (
            <div key={card.id} className="col-sm-6 col-md-4 col-xl">
              {renderCard(card, false)}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ReportKpiCards;
